import { Injectable } from '@angular/core';

@Injectable()
export class HbmathjaxService {

  constructor() { }

  getInputSelection(el) {
    let start = 0; let end = 0; let normalizedValue; let range;
    let textInputRange; let len; let endRange;

    if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {

      range = window.getSelection();
      if (range && range.parentElement() === el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, '\n');

        // Create a working TextRange that lives only in the input
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());


        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart('character', -len);
          start += normalizedValue.slice(0, start).split('\n').length - 1;

          if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd('character', -len);
            end += normalizedValue.slice(0, end).split('\n').length - 1;
          }
        }
      }
    }

    return {
      start,
      end,
    };
  }

  offsetToRangeCharacterMove(el, offset) {
    return offset - (el.value.slice(0, offset).split('\r\n').length - 1);
  }

  setSelection(el, start, end) {
    if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
      el.selectionStart = start;
      el.selectionEnd = end;
    } else if (typeof el.createTextRange !== 'undefined') {
      const range = el.createTextRange();
      const startCharMove = this.offsetToRangeCharacterMove(el, start);
      range.collapse(true);
      if (start === end) {
        range.move('character', startCharMove);
      } else {
        range.moveEnd('character', this.offsetToRangeCharacterMove(el, end));
        range.moveStart('character', startCharMove);
      }
      range.select();
    }
  }
  insertTextAtCaret(el, text) {
    const pos = this.getInputSelection(el).end;
    const newPos = pos + text.length;
    const val = el.value;
    el.value = val.slice(0, pos) + text + val.slice(pos);
    this.setSelection(el, newPos, newPos);
  }
}
